module.exports = __webpack_public_path__ + "img/round-1.44bc8f46.png";